import { CustomDataComponent } from './CustomData';
import { connect } from 'react-redux';

// eslint-disable-next-line no-unused-vars
const mapStateToProps = (state: any) => ({});
const mapDispatchToProps = {};

export const CustomDataStep = connect(mapStateToProps, mapDispatchToProps)(CustomDataComponent);
